// extracted by mini-css-extract-plugin
export var freshers2020page = "index-module--freshers2020page--1XuUV";
export var freshers2021tableContainer = "index-module--freshers2021tableContainer--2X8TM";
export var freshers2021table = "index-module--freshers2021table--1tIKX";
export var noBottom = "index-module--noBottom--2YVvE";
export var freshers2020freshershacklogolink = "index-module--freshers2020freshershacklogolink--2POKd";
export var freshers2020freshershacklogo = "index-module--freshers2020freshershacklogo--3pjxw";
export var freshers2020capturetheflag = "index-module--freshers2020capturetheflag--2wTiN";